export default function PHP_MySQLInsertMultiple() {
  return (
    <div>
      <h1>PHP_MySQLInsertMultiple</h1>
    </div>
  );
}
